import styled from 'styled-components';
export const FilterTitle = styled.h2 `
	color: ${({ theme }) => theme.color.brand1};
`;
export const FilterCount = styled.span `
	color: ${({ theme }) => theme.color.gray5}; ;
`;
